import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Section } from 'components/GridV2';
import { CheckList } from 'components/rebrand/CheckList';
import { H2 } from 'components/rebrand/Typography';

import { INewEnterprisePageSanityBenefit } from 'typescriptDefs/pages/enterprise';

interface Props {
  data: {
    heading: string;
    benefits: INewEnterprisePageSanityBenefit[];
  };
}

const Why = ({ data }: Props) => {
  return (
    <Section className="py-64 md:py-96">
      <Container>
        <H2 className="mx-auto mb-64 px-32 text-center text-primary-350 xs:px-0 md:w-3/5">{data.heading}</H2>
        <div className="grid gap-40 md:gap-64">
          {data.benefits.map((benefit, i) => (
            <div
              className={clsx(
                'grid items-center gap-40 px-32 md:grid-cols-2 md:gap-32 md:px-[unset]',
                i % 2 !== 0 && 'bg-primary-50 py-64 md:bg-inherit md:py-[unset]',
              )}
              key={i}
            >
              <div className={clsx(i % 2 === 0 ? 'md:order-1' : 'md:order-2')}>
                <H2 className="mb-32 text-primary-350 md:w-[90%]">{benefit.heading}</H2>
                <ul>
                  <CheckList
                    itemClassName="[&_p]:w-[98%] [&_p]:text-18"
                    list={benefit.bodyList?.map((item) => item) || []}
                  />
                </ul>
              </div>
              {benefit.imgMain ? (
                <div className={clsx('overflow-hidden rounded-16', i % 2 === 0 ? 'md:order-2' : 'md:order-1')}>
                  <GatsbyImage
                    className="max-h-554"
                    image={benefit.imgMain.asset.gatsbyImageData}
                    alt={benefit.imgMainAltText ?? ''}
                  />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Why;
